// Tailwind Plus Elements, at most once per document (phase 071; owner decision
// 17.10.2026, installed the way lm installed it).
//
// `@tailwindplus/elements` defines its custom elements (`el-dropdown`,
// `el-menu`, `el-dialog`, `el-disclosure`, …) the moment it is evaluated, and a
// second evaluation is a `customElements.define` of a name already taken: the
// browser throws `NotSupportedError`, and the rest of the bundle that loaded it
// — Stimulus included — dies with it. lm lost 355 page loads to exactly that on
// 23–24.09.2026 (`~/p/lm/app/javascript/lib/tailwind_elements_once.js`).
//
// Two guards, because there are two ways to get a second copy:
//
// - a flag on `window`, set before the load: every bundle carries its own copy
//   of this module, so a module variable would be one per bundle, and the
//   document is the only state they share;
// - a `customElements.get` probe, which also sees a copy loaded by a bundle
//   that never ran this module (the library's own guard compares the class,
//   and another copy's class is another class).
//
// The package is imported here and nowhere else, and only dynamically: esbuild
// builds every bundle whole (`esbuild.config.mjs`), so the `import()` below is
// inlined as a lazily evaluated module and the library's top level runs only
// when this function decides it should. `application.ts` and `public_site.ts`
// each call it once, from the bundle their layouts load in `<head>`; a
// `<script>` in `<body>` would be re-run by Turbo on every visit. Both page
// bundles carry the library and the service worker does not (owner decision
// 17.10.2026, `doc/base-ui-seo-pwa-i18n.md` 2.7); no document loads two
// bundles, but the probe below holds even if one ever did.
export const LOADED_FLAG = "__kotofonTailwindElementsLoaded"

// The elements the pages render. A copy loaded elsewhere
// defines every element of the package at once, so finding any of them means
// the library is already in the document.
export const PROBED_ELEMENTS = ["el-dropdown", "el-menu", "el-dialog", "el-disclosure"] as const

type FlaggedWindow = { [LOADED_FLAG]?: boolean }

export type ElementsLoader = () => Promise<unknown>

const loadPackage: ElementsLoader = () => import("@tailwindplus/elements")

export function loadTailwindElementsOnce(load: ElementsLoader = loadPackage): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve()

  const flagged = window as unknown as FlaggedWindow
  if (flagged[LOADED_FLAG] === true) return Promise.resolve()
  flagged[LOADED_FLAG] = true

  const registry = typeof customElements === "undefined" ? undefined : customElements
  if (registry !== undefined && PROBED_ELEMENTS.some((name) => registry.get(name) !== undefined)) {
    return Promise.resolve()
  }

  return load().then(() => undefined)
}
